import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FadeInUp } from '../components/animations';
import SEO from '../components/SEO';
import blogData from '../data/blogData';
import { breadcrumbSchema } from '../utils/schema';
import FeaturedArticle from '../components/blog/FeaturedArticle';
import BlogPostCard from '../components/blog/BlogPostCard';

const BlogPage = () => {
  const featured = blogData[0];
  const rest = blogData.slice(1);

  return (
    <div className="pt-20" data-testid="blog-page">
      <SEO
        title="Sourcing Insights & Blog | Taiga Sourcing"
        description="Articles, guides and insights on sourcing products from India. Category spotlights, buyer guides and quality control tips for international buyers."
        keywords="India sourcing blog, sourcing insights India, India manufacturing articles, India sourcing guide"
        path="/blog"
        schema={breadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'Blog', path: '/blog' },
        ])}
      />

      <section className="relative py-24 lg:py-32 bg-[#071E45] text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <FadeInUp>
            <p className="text-sm tracking-[0.3em] uppercase text-white/50 mb-4 font-medium">Insights</p>
            <h1
              className="text-4xl sm:text-5xl font-bold tracking-tight leading-[1.1] mb-6"
              style={{ fontFamily: 'Cabinet Grotesk' }}
              data-testid="blog-title"
            >
              SOURCING INSIGHTS
            </h1>
            <p className="text-base text-white/70 leading-relaxed max-w-3xl mx-auto">
              Articles, guides and category insights for international buyers sourcing from India.
            </p>
          </FadeInUp>
        </div>
      </section>

      {/* Featured Article */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <FadeInUp>
            <FeaturedArticle post={featured} />
          </FadeInUp>
        </div>
      </section>

      {/* Article Grid */}
      <section className="py-16 lg:py-24 bg-[#fafaf9]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <FadeInUp className="mb-12">
            <h2
              className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0B2A57]"
              style={{ fontFamily: 'Cabinet Grotesk' }}
            >
              ALL ARTICLES
            </h2>
          </FadeInUp>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {rest.map((post, i) => (
              <FadeInUp key={post.slug} delay={i * 0.05}>
                <BlogPostCard post={post} index={i} />
              </FadeInUp>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 lg:py-32 bg-[#071E45] text-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <FadeInUp>
            <h2
              className="text-3xl sm:text-4xl font-bold tracking-tight mb-4"
              style={{ fontFamily: 'Cabinet Grotesk' }}
            >
              HAVE A SOURCING REQUIREMENT?
            </h2>
            <p className="text-base text-white/60 leading-relaxed mb-8">
              Share your product requirement and let us find the right sourcing solution in India.
            </p>
            <Link
              to="/request-sourcing"
              className="inline-flex items-center gap-2 px-10 py-4 bg-white text-[#0B2A57] text-sm font-semibold tracking-wider uppercase transition-all hover:shadow-xl hover:-translate-y-0.5"
            >
              Request Sourcing <ArrowRight size={18} />
            </Link>
          </FadeInUp>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
